<template>
  <div class="ps-lang" data-lang-switcher>
    <button
      class="ps-lang__btn"
      :aria-label="'Change language'"
      @click="open = !open"
      @blur="onBlur"
    >
      <v-icon size="14">fal fa-globe</v-icon>
      <span>{{ currentLabel }}</span>
      <v-icon size="12">fal fa-chevron-down</v-icon>
    </button>

    <div
      v-if="open"
      class="ps-lang__menu"
      :class="direction === 'down' ? 'ps-lang__menu--down' : 'ps-lang__menu--up'"
      @mousedown.prevent
    >
      <button
        v-for="o in options"
        :key="o.code"
        class="ps-lang__option"
        :class="{ 'ps-lang__option--active': locale === o.code }"
        @mousedown.prevent
        @click="choose(o.code)"
      >
        <language-flag :code="o.code" :label="o.label" />
        <v-icon v-if="locale === o.code" size="12" class="ps-lang__check"
          >fal fa-check</v-icon
        >
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PsLanguageSwitcher",
  props: {
    direction: { type: String, default: "up" }, // 'up' | 'down'
  },
  data: () => ({
    open: false,
  }),
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    options() {
      return [
        { code: "la", label: "ລາວ" },
        { code: "en", label: "English" },
        { code: "th", label: "ไทย" },
        { code: "ch", label: "中文" },
      ];
    },
    currentLabel() {
      const found = this.options.find((o) => o.code === this.locale);
      return found ? found.label : "ລາວ";
    },
  },
  methods: {
    choose(code) {
      localStorage.setItem("locale", code);
      this.$i18n.locale = code;
      this.open = false;
    },
    onBlur() {
      // allow option click to finish before closing
      setTimeout(() => {
        this.open = false;
      }, 150);
    },
  },
};
</script>

<style scoped>
.ps-lang {
  position: relative;
}

.ps-lang__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #141021;
  font-size: 12px;
  font-weight: 900;
  color: var(--ps-ink);
  transition: background-color 0.15s ease;
}
.ps-lang__btn:hover {
  background: var(--ps-brand-soft);
}

.ps-lang__menu {
  position: absolute;
  right: 0;
  width: 144px;
  background: #fff;
  border: 1px solid #141021;
  border-radius: 12px;
  box-shadow: var(--ps-shadow-hard);
  overflow: hidden;
  z-index: 50;
}
.ps-lang__menu--down {
  top: calc(100% + 8px);
}
.ps-lang__menu--up {
  bottom: calc(100% + 8px);
}

.ps-lang__option {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 900;
  color: var(--ps-ink);
  background: transparent;
  border: none;
  transition: background-color 0.15s ease;
}
.ps-lang__option:hover {
  background: var(--ps-brand-soft);
}
.ps-lang__option--active {
  background: var(--ps-brand);
  color: #fff;
}
.ps-lang__option--active:hover {
  background: var(--ps-brand);
}

.ps-lang__check {
  margin-left: auto;
}
</style>
